import { render } from "./formDialog.vue?vue&type=template&id=120c7df2"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__